import { render, staticRenderFns } from "./deleteCommunityRecommend.vue?vue&type=template&id=6219b266&scoped=true"
import script from "./deleteCommunityRecommend.vue?vue&type=script&lang=js"
export * from "./deleteCommunityRecommend.vue?vue&type=script&lang=js"
import style0 from "./deleteCommunityRecommend.vue?vue&type=style&index=0&id=6219b266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219b266",
  null
  
)

export default component.exports